import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhoShouldTest from './components/WhoShouldTest';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import Pricing from './components/Pricing';
import FAQs from './components/FAQs';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'MedicalBusiness',
      name: 'AltaLumé ADHD Testing',
      url: siteUrl,
      description:
        'AltaLumé provides online ADHD attention testing using the IVA-2 Continuous Performance Test. Results are for informational purposes only and are not a medical diagnosis.',
      areaServed: 'US',
      medicalSpecialty: 'Psychiatry',
      availableService: {
        '@type': 'MedicalTest',
        name: 'IVA-2 Continuous Performance Test',
        usesDevice: {
          '@type': 'MedicalDevice',
          name: 'IVA-2 CPT',
        },
      },
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'admin@altalume.com',
        contactType: 'customer support',
      },
    });
    if (!document.getElementById('schema-home')) {
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />
      <HeroSection />
      <WhoShouldTest />
      <HowItWorks />
      <Benefits />
      <Pricing />
      <FAQs />
      <Contact />
      <Footer />
    </div>
  );
}
